export default "__VITE_ASSET__DR8F2U5k__"